import { useCallback } from "react";

import type { Facility } from "@/lib/gql/__generated__/graphql";

import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useFacilitiesOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { facilities } = viewModel;

	const updateFacilities: (checked: boolean, facility: Facility) => void = useCallback(
		(checked, facility) => {
			const newFacilities = {
				...facilities,
			};

			if (checked) {
				newFacilities.value.push({ value: facility, isEdited: false });
			} else {
				newFacilities.value = facilities.value.filter(({ value }) => value !== facility);
			}

			onSetViewModel([{ key: "facilities", value: newFacilities }]);
		},
		[facilities, onSetViewModel],
	);

	return {
		facilities,
		updateFacilities,
	};
};
